module.exports = __webpack_public_path__ + "img/aqua.fcb08728.svg";